import React, {Component} from 'react'
import FontAwesome from 'react-fontawesome'
import { Pagination, Button, Form, FormControl, FormGroup, InputGroup, Modal, ButtonToolbar, Row, Col, ControlLabel } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import { Checkbox } from 'react-icheck'
import StockStore from 'stores/StockStore'
import AutopartStore from 'stores/AutopartStore'
import {connect} from 'react-redux'
import './Stock.css'
import No_img from '../../asset/img/no_image.jpg'
import CKAutocomplete from 'component/element/CKAutocomplete'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import $ from 'jquery'

const NotificationSystem = require('react-notification-system')
class StockSpecification extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      query:'',
      showItemMore0:false,
      length:10,
      totalPage:1,
      activePage:1,
      show:false,
      files:[],
      data:[],
      doc:this.getEmptyDoc(),
      partlist:[]
    }
  }

  componentDidMount() {
    this.loadData()

    // $('body').on('keydown', ()=> {
    //   if ($('.tdTypeaHead > div.bootstrap-typeahead').children().length>1) {
    //     $('.table-partlist').css( "overflow-x", "initial" );
    //     $('.table-partlist').css( "overflow-y", "unset" );
    //   } else {
    //     $('.table-partlist').css( "overflow-x", "auto" );
    //     $('.table-partlist').css( "overflow-y", "" );
    //   }
    // });

    // $('body').on('click', ()=> {
    //   if ($('.tdTypeaHead > div > ul').hasClass('bootstrap-typeahead-menu')||$('.tdProductcode > div > div').hasClass('ck-autocomplete-box')) {
    //     $('.table-partlist').css( "overflow-x", "initial" );
    //     $('.table-partlist').css( "overflow-y", "unset" );
    //   } else {
    //     $('.table-partlist').css( "overflow-x", "auto" );
    //     $('.table-partlist').css( "overflow-y", "" );
    //   }
    // });
  }

  getEmptyDoc() {
    return {
      added_by: "",
      added_date: "",
      barcode: "",
      category: "0",
      container_quantity: "",
      container_unit: "",
      cost_per_unit: "",
      description: "",
      error_quantity: "0",
      is_container: "0",
      itemnum: "",
      location: "",
      price_per_unit: "",
      productcode: "",
      quantity: "",
      quantity_per_container_unit: "",
      remark: null,
      thumbnail_url: null,
      unit: "",
      warning_quantity: "",
    }
  }

  newEmptyRow(number) {
    return new Array(number).fill(null).map((item, index) => {
      return {unit:'',quantity:'',description:'',productcode:'',code_options:[],itemnum:''}
    })
  }

  loadData() {
    let {activePage,length,showItemMore0} = this.state
    let start = 0
    if (activePage===1) {
      start = 0
    } else {
      start = (activePage*length)-length
    }
    this.setState({loading:true})
    StockStore.loadStockSpecifications(start,length,(result)=>{
      let dataMap = result.data
      if (showItemMore0) {
        dataMap = []
        let dataAll = []
        let i = 0
        if (start===0) 
          start = length
        else {
          start = (start*1)+length
          i = start - length
        }
        
        result.data.forEach((item,index)=>{
          if (item.quantity>0) {
            dataAll.push(item)
          }
        })
        totalPage = dataAll.length/length
        dataAll.forEach((item,index)=>{
          if (index>=i&&index<start) {
            dataMap.push(item)
          }
        })  
      }
      let totalPage = result.total_count/length
      this.setState({loading:false,data:dataMap,totalPage:Math.ceil(totalPage)})
    })
  }

  onSearchClick() {
    this.loadData()
  }

  onSearchKeyPress(e) {
    if (e.charCode===13) {
      e.preventDefault()

      this.loadData()
    }
  }

  onQueryChange(e) {
    this.setState({query:e.target.value})
  }

  onShowItemMore0() {
    let {showItemMore0} = this.state
    if (showItemMore0) {
      showItemMore0 = false
    } else {
      showItemMore0 = true
    }
    this.setState({showItemMore0:showItemMore0,activePage:1},()=>{
      this.loadData()
    })
  }

  onPageSelect(page) {
    this.setState({activePage:page},()=>{
      this.loadData()
    })
  }

  onHide() {
    this.setState({show:false})
  }

  onFormChange(index,field,e) {
    let {partlist} = this.state
    partlist[index][field] = e.target.value
    if (field==='productcode') {
      if (partlist[index][field].length>=3) {
        this.onSearchProductCode(index,partlist[index][field])
      } else if (partlist[index][field]==='') {
        partlist[index].code_options = []
      }
    } 
    this.setState({partlist:partlist})
  }

  onFormSelect(index,field,e,item_select) {
    let {partlist} = this.state
    if (field==='productcode') {
      let item = item_select  
      partlist[index].description = item.detail        
      partlist[index].quantity = item.quantity
      partlist[index].itemnum = item.itemnum  
      partlist[index].productcode = item.productcode  
      partlist[index].unit = item.unit
    } else {
      partlist[index][field] = e
    }
    this.setState({partlist:partlist})
  }

  onSearchProductCode(index,query) {
    let {partlist} = this.state
    AutopartStore.loadStockPartProductCode(query,(result)=>{
      let options = result.data.map((item,index)=>{
        return {
          productcode:item.productcode,
          itemnum:item.itemnum,
          detail:item.description,
          label:item.productcode+' - '+item.description+(item.cat_name!==''&&item.cat_name!==null&&item.cat_name!==undefined?' (หมวด'+item.cat_name+')':''),
          value:item.productcode,
          quantity:item.quantity,
          unit:item.unit
        }
      })
      partlist[index].code_options = options
      this.setState({partlist:partlist})
    })
  }

  onDocChange(field,e) {
    let {doc} = this.state
    doc[field] = e.target.value
    this.setState({doc:doc})
  }

  onContainerCheckChange() {
    let {doc} = this.state
    if (doc.is_container==='1') {
      doc.is_container = '0'
    } else {
      doc.is_container = '1'
    }  
    this.setState({doc:doc})
  }

  onStockCardCheckChange() {
    let {doc} = this.state
    if (doc.is_stock_card==='1') {
      doc.is_stock_card = '0'
    } else {
      doc.is_stock_card = '1'
    }  
    this.setState({doc:doc})
  }

  onUploadClick() {
    
  }

  onImgClick() {

  }

  onRowAdd(number) {
    let {partlist} = this.state
    partlist = partlist.concat(this.newEmptyRow(number))
    this.setState({partlist:partlist})
  }

  onRowSelect(item) {
    StockStore.loadStockSpecificationItem(item.itemnum,(result)=>{
      let partlist = result.data.itemlist.map((item,index)=>{
        item = Object.assign(item,{code_options:[]})
        return item
      })
      this.setState({show:true,partlist:partlist,doc:result.data.spec})
    })
  }

  onSearch(index,query){
    AutopartStore.loadStockPartItemList(-1,query,(result)=>{
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,quantityit:item.quantityit,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,price_per_unit:item.price_per_unit,cost_per_unit:item.cost_per_unit,quantity:item.quantity,unit:item.unit,is_product_lot:item.is_product_lot,po_date:item.po_date}
      })
      this.setState({options:options})
    })
  }

  onTypeaheadInputChange(index,query){
    let {partlist} = this.state
    partlist[index]['description'] = query
    this.setState({partlist:partlist})
  }

  onTypeaheadChange(index,option){
    let {partlist} = this.state
    if(option.length===1){
      partlist[index].description = option[0].detail
     if(option[0].itemnum!==undefined){
        partlist[index].itemnum = option[0].itemnum
        partlist[index].unit = option[0].unit
        partlist[index].productcode = option[0].productCode
        partlist[index].quantity = option[0].quantityit
      }
    }
    this.setState({partlist:partlist})
  }

  onSaveClick() {
    let {doc,partlist} = this.state
    let postData = {spec:doc,itemlist:partlist}
    StockStore.saveStockSpecificationItem(postData,(result)=>{
      if (result.status==='OK') {
        doc.itemnum = result.itemnum
        this.setState({doc:doc})
        this.refs.notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'บันทึกรายการสำเร็จ',
          level:'info',
          position:'tc'
        });
      }
    },()=>{
      this.refs.notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ไม่สามารถบันทึกรายการได้',
        level:'error',
        position:'tc'
      });
    })
  }

  onDelClick(index) {
    let {partlist} = this.state
    if (partlist[index].itemnum==='')
      partlist.splice(index,1)
    else
      partlist[index] = Object.assign(partlist[index],{force_delete:true})
    this.setState({partlist:partlist})
  }

  _renderMenuItemChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName})</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index} onClick={this.onRowSelect.bind(this,item)}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.productcode}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    return(
        <div className='table-responsive'>
          <table className="table table-hover table-bordered-solid">
            <thead>
              <tr>
                <th style={{width:'50px'}} className="text-center">ลำดับ</th>
                <th style={{width:'120px'}} className="text-center">รหัส Spec</th>
                <th style={{width:'200px'}} className="text-center">ชื่อรายการ / Specification</th>
                <th style={{width:'90px'}} className="text-center">จำนวน</th>
                <th style={{width:'100px'}} className="text-center">หน่วย</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
          </table>
        </div>
    )
  }

  renderImage() {
    let {files} = this.state
    if (files.length>0) {
      return (
        <Row>
          <Col xs={12}>
            <img src={No_img} width="100%" height="100%" />
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col xs={6}>
            <img src={No_img} width="100%" height="100%" />
          </Col>
          <Col xs={6}>
            <h4 style={{ color: "#337ab7" }}>รูปสินค้า</h4>
            <h5>0 รูป</h5>
          </Col>
        </Row>
      )
    }
  }

  renderPartlistRowData() {
    let {partlist,options} = this.state
    let itemlist = []
    partlist.forEach((item,index)=>{
      if (typeof item.force_delete==='undefined'||!item.force_delete)
        itemlist.push(item)
    })
    if (itemlist.length===0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        partlist.map((item,index)=>{
          return(
            <tr key={index} style={{display:(item.force_delete?'none':'')}}>
              <td className='text-center data-column tdProductcode'>
                <CKAutocomplete
                  top='-35px'
                  items={item.code_options}
                  value={item.productcode}
                  onChange={this.onFormChange.bind(this,index,'productcode')}
                  onSelect={this.onFormSelect.bind(this,index,'productcode')}
                  shouldItemRender={null}
                />  
              </td>
              <td className='text-left data-column tdTypeaHead'>
                <AsyncTypeahead
                  allowNew={false}
                  multiple={false}
                  newSelectionPrefix={'เพิ่มรายการใหม่ : '}   
                  promptText={'พิมพ์รายการเพื่อค้นหา...'}           
                  searchText={'กำลังค้นหา...'}                    
                  selected={[{detail:item.description}]}
                  options={options}
                  labelKey="detail"
                  onSearch={this.onSearch.bind(this,index)}
                  onChange={this.onTypeaheadChange.bind(this,index)}
                  onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                  placeholder=""
                  renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
                />
              </td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.quantity}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>{item.unit}</td>
              <td style={{verticalAlign:'middle'}} className='text-center'>
                <Button bsStyle='danger' onClick={this.onDelClick.bind(this,index)}><FontAwesome name='trash' /></Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderForm() {
    let {doc} = this.state
    let cUnit = (doc.container_unit!==''&&doc.container_unit!==null&&doc.container_unit!==undefined?doc.container_unit:'หน่วยใหญ่')
    return(
      <div>
        <Row>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>รหัส Spec</ControlLabel>
              <FormControl className='text-center' value={doc.productcode} onChange={this.onDocChange.bind(this,'productcode')} />
            </FormGroup>
          </Col>
          <Col md={9} sm={9}>
            <FormGroup>
              <ControlLabel>ชื่อรายการ / Specification</ControlLabel>
              <FormControl value={doc.description} onChange={this.onDocChange.bind(this,'description')} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={3}>
            <Checkbox
              onChange={this.onContainerCheckChange.bind(this)}
              checked={doc.is_container==='1'?true:false}
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label=" มีหน่วยใหญ่"
            />
            {' '}
            <Checkbox
              onChange={this.onStockCardCheckChange.bind(this)}
              checked={doc.is_stock_card==='1'?true:false}
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label=" มี Stock Card"
            />
          </Col>
        </Row>
        <Row style={{display:(doc.is_container==='1'?'':'none')}}>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>{'หน่วยนับ'+' ('+cUnit+')'}</ControlLabel>
              <FormControl className='text-center' value={doc.container_unit!==null?doc.container_unit:''} onChange={this.onDocChange.bind(this,'container_unit')} />
            </FormGroup>
          </Col>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>{'ปริมาตร(จำนวน) ต่อ'+cUnit}</ControlLabel>
              <FormControl className='text-right' value={doc.quantity_per_container_unit} onChange={this.onDocChange.bind(this,'quantity_per_container_unit')} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>หน่วย</ControlLabel>
              <FormControl className='text-center' value={doc.unit!==null?doc.unit:''} onChange={this.onDocChange.bind(this,'unit')} />
            </FormGroup>
          </Col>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>จำนวน ({doc.unit===''?'-':doc.unit})</ControlLabel>
              <FormControl className='text-right' value={doc.quantity} onChange={this.onDocChange.bind(this,'quantity')} />
            </FormGroup>
          </Col>
          <Col md={6} sm={6}>
            <FormGroup>
              <ControlLabel>หมายเหตุ</ControlLabel>
              <FormControl value={doc.remark!==null?doc.remark:''} onChange={this.onDocChange.bind(this,'remark')} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>ภาพประกอบ <Button style={{display:(doc.itemnum!=='')?'':'none'}} bsStyle='link' onClick={this.onUploadClick.bind(this)}>อัพโหลด</Button></ControlLabel>
              <div className="box-up-img" style={{maxWidth:'320px'}} onClick={this.state.files.length>0?this.onImgClick.bind(this):()=>{}}>
                <div style={{padding:"5px"}}>
                  {this.renderImage()}
                </div>
              </div>
            </FormGroup>
          </Col>
          <Col md={9} sm={9}>
            <FormGroup>
              <ControlLabel>รายการอะไหล่ใน Spec</ControlLabel>
              <div className='table-partlist'>
                <table className="table table-hover table-bordered-solid" style={{marginBottom:'0'}}>
                  <thead>
                    <tr>
                      <th style={{width:'100px'}} className="text-center">รหัสสินค้า</th>
                      <th style={{width:'200px'}} className="text-center">ชื่อรายการ</th>
                      <th style={{width:'90px'}} className="text-center">จำนวน</th>
                      <th style={{width:'100px'}} className="text-center">หน่วย</th>
                      <th style={{width:'50px'}} className="text-center">ลบ ?</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderPartlistRowData()}
                  </tbody>
                </table>
              </div>
              <div style={{marginTop:'5px'}}>
                <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus' />&nbsp;เพิ่ม</Button>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </div>
    )
  }

  renderAddModal() {
    let {show} = this.state
    return(
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>เพิ่ม/แก้ไข รายการ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderForm()}    
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/>&nbsp;บันทึก</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;ปิด</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }

  render() {
    let {loading,query,showItemMore0} = this.state
    return(
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>Specification</Box.Title>
            <Box.Tools>
              <Button
                bsStyle={'link'} 
                className='text-large'
                onClick={()=>{this.setState({show:true,doc:this.getEmptyDoc(),partlist:[]})}}
              >
                <FontAwesome name='plus' /> เพิ่มรายการ
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <Form inline style={{marginBottom:'5px'}}>
              <FormGroup>
                <InputGroup>
                  <InputGroup>
                    <FormControl value={query} placeholder={'ชื่อรายการ...'} onChange={this.onQueryChange.bind(this)} onKeyPress={this.onSearchKeyPress.bind(this)} />
                    <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}>
                      <FontAwesome name='search' />
                    </InputGroup.Addon>
                  </InputGroup>
                </InputGroup>
              </FormGroup>
              {' '}
              <FormGroup>
                <Checkbox
                  onChange={this.onShowItemMore0.bind(this)}
                  checked={showItemMore0}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' แสดงเฉพาะที่มีจำนวน'}
                />
              </FormGroup>
            </Form>
            {this.renderTable()}
          </Box.Body>    
        </Box>
        <div>
          <div className="text-right">
            <Pagination
              prev={'ย้อนกลับ'}
              next={'ถัดไป'}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.onPageSelect.bind(this)}
            />
          </div>
        </div>
        {this.renderAddModal()}
        <NotificationSystem ref="notificationSystem" /> 
      </div>
    )
  }
}

StockSpecification.defaultProps = {
  
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockSpecification}),null,null,{withRef:true},
)(StockSpecification);





// WEBPACK FOOTER //
// ./src/view/stock/StockSpecification.js